import React from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';

type TicketTextFieldProps = Omit<UseFormRegisterReturn, 'ref'> & {
  id: string;
  label?: string;
  type?: string;
};

// Required single-line text input matching the support-ticket form field markup.
// Spread a react-hook-form `register()` result onto it so the form owns the value;
// the invalid state is the browser's own, styled via `:invalid`.
export const TicketTextField = React.forwardRef<HTMLInputElement, TicketTextFieldProps>(
  ({ id, label, type = 'text', ...registration }, ref) => (
    <div className="support-ticket-field-group">
      <label htmlFor={id} className="support-ticket-label">
        <span aria-hidden="true">*</span> {label}
      </label>
      <input id={id} type={type} ref={ref} {...registration} className="support-ticket-input" />
    </div>
  )
);

TicketTextField.displayName = 'TicketTextField';
